<template>
  <section class="homeRegions">
    <div class="homeRegions-heroImage">
      <img class="homeRegions-heroImage" alt="" src="@/assets/images/regions/hero.jpg" />
    </div>
    <div class="homeRegions-titlebox">
      <h2 class="homeRegions-title">Island Spotlight <br/> Turks and Caicos</h2>
      <div class="homeRegions-textWrap">
        <p class="homeRegions-text">
          World-class living across some of 
          <br/> the most exclusive islands in the Caribbean
        </p>
        <button class="homeRegions-button" @click="$router.push({ name: 'ListingsPage' })">
          ALL LISTINGS
        </button>
      </div>
    </div>
    <div class="homeRegions-contentbox">
      <div class="homeRegions-contentItem" v-for="region in displayedRegions" :key="region.id" @mouseenter="scrollToItem" @click="handleRegionClick($event, region)">
        <div class="homeRegions-contentItem-image">
          <img :src="region.image" :alt="region.title" />
        </div>
        <div class="homeRegions-contentItem-title">
          <span>{{ region.title }}</span>
          <SvgComponent name="arrow" />
        </div>
        <div class="homeRegions-contentItem-desc">{{ region.desc }}</div>
      </div>
      <button class="showMore" @click="$router.push({ name: 'ListingsPage' })">
        ALL LISTINGS
      </button>
    </div>
  </section>
</template>

<script>
  export default {
    components: {
      SvgComponent: () => import('@/components/SvgComponent'),
    },
    data() {
    return {
      isMobile: false,
      regions: [
        {
          id: 'providenciales',
          image: require('@/assets/images/regions/providenciales.jpg'),
          title: 'Providenciales',
          desc: "The epicenter of luxury living, with Grace Bay's iconic beaches, world-class villas, and refined island lifestyle",
        },
        {
          id: 'grand-turk',
          image: require('@/assets/images/regions/grand-turk.jpg'),
          title: 'Grand Turk',
          desc: 'Historic charm and colonial elegance, offering intimate settings and exclusive seaside retreats'
        },
        {
          id: 'north-caicos',
          image: require('@/assets/images/regions/north-caicos.jpg'),
          title: 'North Caicos',
          desc: 'Lush landscapes and secluded shores — ideal for private villas and serene island living'
        },
        {
          id: 'middle-caicos',
          image: require('@/assets/images/regions/middle-caicos.jpg'),
          title: 'Middle Caicos',
          desc: 'Dramatic cliffs and hidden coves create a breathtaking backdrop for rare and exclusive estates'
        },
        {
          id: 'south-caicos',
          image: require('@/assets/images/regions/south-caicos.jpg'),
          title: 'South Caicos',
          desc: 'Authentic and tranquil, where heritage meets privacy in pristine oceanfront residences'
        }
      ]
    }
  },
    computed: {
    displayedRegions() {
      return this.isMobile ? this.regions.slice(0, 3) : this.regions;
    }
  },
   mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    handleRegionClick(event, region) {
      const url = this.$router.resolve({ name: 'ListingsPage', query: { region: region.title } }).href;
      if (event.ctrlKey || event.metaKey) {
        window.open(url, '_blank');
      } else {
        this.$router.push(url);
      }
    },
    scrollToItem(e) {
      if (this.isMobile) return;
      const item = e.currentTarget;
      clearTimeout(this._scrollTimeout);
      this._scrollTimeout = setTimeout(() => {
        if (!item.matches(':hover')) return;
        const container = item.parentElement;
        const containerWidth = container.clientWidth;
        const expandedWidth = containerWidth * 0.5 - 24;
        const containerRect = container.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const itemLeft = itemRect.left - containerRect.left + container.scrollLeft;
        const itemRight = itemLeft + expandedWidth;
        const visibleRight = container.scrollLeft + containerWidth;

        if (itemRight > visibleRight) {
          container.scrollTo({
            left: itemRight - containerWidth + 40,
            behavior: 'smooth',
          });
        }
      }, 600);
    }
  }
  };
</script>

<style lang="scss">
  .homeRegions {
  background: #FFFAF3;
  color: #1F1E1E;
  margin-bottom: 120px;

  @include tablet {
    margin-bottom: 60px;
  }

  @include phone {
    margin-bottom: 0;
  }

  &-heroImage {
    margin-bottom: 125px;
    width: 100%;

    @include tablet {
      margin-bottom: 60px;
    }

    @include phone {
      margin-bottom: 32px;
      height: 390px;

      img {
        object-fit: cover;
      }
    }
  }

  &-titlebox {
    padding: 0 100px;
    display: flex;
    gap: 30px;
    margin-bottom: 63px;

    @include tablet {
      padding: 0 0 40px 0;
      gap: 20px;
      margin-bottom: 0px;
      justify-content: center;
    }

    @include phone {
      padding: 0;
      flex-direction: column;
      margin: 0 16px 24px;
      gap: 0;
    }

    h2 {
      font-family: 'Abhaya Libre';
      font-weight: 800;
      width: 638px;
      text-align: right;
      font-size: 72px;


      @include tablet {
        font-size: 50px;
        line-height: 50px;
        width: auto;
      }

      @include phone {
        width: 100%;
        font-size: 42px;
        text-align: left;
        margin-left: 0;
      }
    }

    .homeRegions-textWrap {
      display: flex;
      flex-direction: column;
      gap: 20px;

      @include tablet {
        gap: 12px;
        width: 400px;
      }


      .homeRegions-text {
        font-size: 18px;
        font-weight: 400;
        width: 340px;
        margin-top: 20px;

        @include tablet {
          font-size: 18px;
          margin-top: 8px;
          width: auto;
        }

        @include phone {
          display: none;
        }
      }

      .homeRegions-button {
        padding: 15px 30px;
        text-transform: uppercase;
        border: 1px solid #d41e34;
        width: max-content;
        font-size: 17px;
        font-weight: 700;
        color: #d41e34;
        cursor: pointer;

        &:hover {
          background: #d41e34;
          color: white;
          transition: ease-in-out 0.2s;
        }

        @include tablet {
          padding: 12px 24px;
        }

        @include phone {
          display: none;
        }
      }
    }
  }

  &-contentbox {
    margin: 0 100px;
    padding-bottom: 60px;
    display: flex;
    gap: 30px;
    overflow-x: scroll;

    @include tablet {
      margin: 0 50px;
      padding-bottom: 40px;
      gap: 20px;
    }

    @include phone {
      flex-direction: column;
      margin: 0 16px;
      gap: 24px;
    }

    .homeRegions-contentItem {
      width: calc(25% - 21px);
      overflow: hidden;
      height: 600px;
      transition: width 0.4s ease-in-out 0.3s;
      position: relative;
      flex-shrink: 0;
      padding: 40px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      color: white;
      cursor: pointer;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 70.02%, rgba(0, 0, 0, 0.405) 84.28%, rgba(0, 0, 0, 0.45) 100%);
        z-index: 1;
      }

      @include tablet {
        height: 360px;
        padding: 20px;
        width: calc(25% - 16px);
      }

      

      @include phone {
        width: 100% !important;
        padding: 0;
        height: 100%;
        color: #1F1E1E;

        &:before {
          display: none;
        }
      }

      &-image {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;

        @include phone {
          width: 100%;
          position: relative;
          height: 368px;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease-out;
        }
      }

    &-title {
      z-index: 2;
      position: relative;
      font-size: 24px;
      font-weight: 700;
      display: flex;
      align-items: center;
      gap: 16px;

        svg {
          display: none;
          transform: rotate(180deg);
        }

        @include tablet {
          span {
            hyphens: auto;
            overflow-wrap: break-word;
            word-break: break-word;
          }
        }

        @include phone {
          margin-top: 16px;

          svg {
            display: block;
          }
        }
      }

    &-desc {
      z-index: 2;
      max-height: 0;
      opacity: 0;
      overflow: hidden;
      transition: max-height 0.4s ease-in-out 0s, opacity 0.3s ease-out 0s, margin-top 0.4s ease-in-out 0s;

      @include phone {
        max-height: none;
        opacity: 1;
        overflow: visible;
        font-size: 16px;
        line-height: 16px;
        margin-top: 8px;
      }
    }

    &:hover {
      width: calc(50% - 11px);
      transition: width 0.4s ease-in-out 0s;

      .homeRegions-contentItem-desc {
        max-height: 6em;
        opacity: 1;
        margin-top: 8px;
        transition: max-height 0.4s ease-in-out 0.3s, opacity 0.4s ease-in-out 0.3s, margin-top 0.4s ease-in-out 0.3s;
      }

      }
    }

    .showMore {
      width: 100%;
      padding: 16px;
      background: #1F1E1E;
      color: #FFFAF3;
      border: none;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      text-transform: uppercase;
      text-align: center;
      display: none;

      @include phone {
        display: block;
      }
    }

    &:has(.homeRegions-contentItem:hover) .homeRegions-contentItem:not(:hover) {
      /* width: calc(25% - 21px); */

      .homeRegions-contentItem-desc {
        height: 0;

        @include tablet {
          /* width: 290px; */
        }

        @include phone {
          height: max-content;
          width: 100%;
        }
      }
    }

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 4px;
      transition: background 0.2s ease-out;
      cursor: pointer;

      &:hover {
        background: $red;
        transition: background 0.2s ease-in;
      }
    }

    &::-webkit-scrollbar-track {
      background: #EDEDED;
      border-radius: 4px;

      @include phone {
        display: none;
      }
    }
  }
}
</style>